var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetworkIconColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.384,
    height: 28.385,
    viewBox: "0 0 28.384 28.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#fbbf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbf02"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3504",
    "data-name": "Groupe 3504",
    transform: "translate(0.001 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M16009.974,24440.248a2.8,2.8,0,1,1,2.8,2.8A2.8,2.8,0,0,1,16009.974,24440.248Zm8.5-1.729a2.8,2.8,0,0,1,3.957-3.957l.006.006a2.787,2.787,0,0,1-.006,3.951v.006a2.794,2.794,0,0,1-3.957-.006Zm-15.379,0a2.8,2.8,0,1,1,3.963-3.957v.006a2.793,2.793,0,0,1,0,3.951l-.006.006a2.794,2.794,0,0,1-3.957-.006Zm5.791-9.668a3.88,3.88,0,1,1,3.883,3.883A3.884,3.884,0,0,1,16008.888,24428.852Zm15.269,2.8a2.8,2.8,0,1,1,.012,0Zm-25.58-2.791a2.8,2.8,0,1,1,2.8,2.791A2.8,2.8,0,0,1,15998.576,24428.863Zm19.9-5.717v-.006a2.8,2.8,0,0,1,0-3.957h.006a2.8,2.8,0,0,1,3.957,0v.006a2.8,2.8,0,0,1-3.963,3.957Zm-15.379,0v-.006a2.8,2.8,0,0,1,0-3.957h.006a2.8,2.8,0,0,1,3.957,0v.006a2.8,2.8,0,0,1-3.963,3.957Zm6.871-5.682a2.8,2.8,0,1,1,2.8,2.793A2.8,2.8,0,0,1,16009.968,24417.465Z",
    transform: "translate(-15998.577 -24414.664)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIconColor);
export default __webpack_public_path__ + "static/media/networkIconColor.ff40d651cbfb10462c0350c3051f0ee4.svg";
export { ForwardRef as ReactComponent };